import { AppData } from "../data"

export class MapTool {
    static moveToLocation = (loc) => {
        let camera = AppData.map?.getCamera()
        camera?.setCenter(loc)
        AppData.map?.moveCamera(camera, { animate: true })
    }

    static moveWithPadding = (map, target, padding = { top: 0, left: 0, right: 0, bottom: 0 }, option) => {
        if (!target) {
            return
        }
        map.panTo(target, padding)
    }
}
